<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Điểm danh</v-tab>
    </v-tabs>
    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <TabAttendance />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import TabAttendance from './tab-attendance'
export default {
  components: { TabAttendance },
  data: () => ({ tab: null }),
}
</script>